/**
 * Update
 */

import Config from '../Config';
import Util from '../Util';
import ParamInfo from './ParamInfo';
import GameInfo from '../GameInfo';

class Update {
  private guid: string;

  private _id: string;

  private gameServerName: string;

  private gameServerId: string;

  private articleId: string;

  private selector: string;

  private paramInfo: ParamInfo;

  private categoryId: string;

  constructor(guid: string, parentId: string = '', gameServerName: string = '', gameServerId: string = '', categoryId: string = '') {
    this.guid = guid;
    this._id = parentId || `viewMoreList`;
    this.gameServerName = gameServerName;
    this.gameServerId = gameServerId;
    this.paramInfo = new ParamInfo();
    this.paramInfo.setParamByUrl();
    this.articleId = this.paramInfo.getParamByKey('articleId');
    this.categoryId = categoryId;

    this.addSelector();
    this.show();
    this.addEvent();
  }

  public show() {
    jQuery(this.selector).hide();

    if (Config.guid && this.guid && Config.guid === this.guid) {
      jQuery(this.selector).show();
    }

    if (this.gameServerName && this.gameServerId && GameInfo.isEqualGameUser(this.gameServerName, this.gameServerId)) {
      jQuery(this.selector).show();
    }
  }

  private addSelector() {
    // this.selector = `#${this._id} .co-btn-modify`;
    this.selector = `.${Config.COMMUNITY_NODE} .co-btn-modify`;
  }

  private addEvent() {
    jQuery('body').on('click', this.selector, evt => {
      evt.preventDefault();

      if (Config.isMobileSdk) {
        location.href = Config.mobileSdk.articleModify();
        return;
      }

      const CATEGORY_ID = 'categoryId';
      const params =
        this.paramInfo.getParamByKey(CATEGORY_ID) === '0' ? `${this.paramInfo.getParamIgnore(CATEGORY_ID)}&${CATEGORY_ID}=${this.categoryId}` : this.paramInfo.getParam();

      location.href = Config.writePage + '?' + params;
    });
  }
}

export default Update;
